<!-- @format -->

<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
import './style/base.css'
export default {
	data() {
		return {}
	},
	created() {},

	async mounted() {},
	methods: {},
	name: 'App',
}
</script>
<style lang="less">
#app {
	height: 100vh;
}
</style>
